import castArray from "lodash/fp/castArray";
import isArray from "lodash/fp/isArray";

export function getIsDisabled(userChoiceValues = {}) {
  return (isDisabledIf = {}) =>
    Object.keys(isDisabledIf).some((key) => {
      const { includes, notIncludes } = isDisabledIf[key];
      if (
        includes &&
        castArray(includes).includes(userChoiceValues[key] || "")
      ) {
        return true;
      }
      if (
        notIncludes &&
        castArray(!notIncludes).includes(userChoiceValues[key] || "")
      ) {
        return true;
      }
      return false;
    });
}

export default function getFieldsWithIsDisabledValue(userChoiceValues) {
  function doFieldsWithIsDisabledValue(fields) {
    return fields.map((field) => {
      if (isArray(field)) {
        return doFieldsWithIsDisabledValue(field);
      }
      const { isDisabledIf, ...fieldProps } = field;
      return {
        ...fieldProps,
        isDisabled: getIsDisabled(userChoiceValues)(isDisabledIf),
      };
    });
  }

  return doFieldsWithIsDisabledValue;
}
